import React from 'react';

import QuoteService from '../../services/quoteService';
import { getTranslations } from '../../services/languageUtils';

import BRL from '../../assets/imgs/BRL.png';
import USDT from '../../assets/imgs/usdt.png';
import BTC from '../../assets/imgs/bitcoin.png';

const coins = [
    {value:'BRL', label: 'Real', image: BRL},
    {value:'USDT', label: 'Tether', image: USDT},
    {value:'BTC', label: 'Bitcoin', image: BTC},
];

var dayOfWeek = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]

class CoinQuote extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataStock: [],
      dispQuotes: true,
      translations: {}
    };
  }

  loadTranslations = async () => {
    const translations = await getTranslations((localStorage.getItem('language') || 'pt'));
    this.setState({ translations });
  };

  componentDidMount() {
    this.refresh();
    this.loadTranslations();
  }

  refresh() {
    let that = this;
    let temp = [];
    temp.push({
      image: BRL,
      label: 'BRL',
      open: 1.0,
      close: 1.0
    });
    for(let k=1; k<coins.length; k++){
      QuoteService.getQuoteDays(coins[k].value + '-BRL', 1).then(function(res){
          temp.push({
            label: res.data[0].code==="USD"?"USDT":res.data[0].code,
            open: 1,
            close: res.data[0].bid,
            image: coins[k].image
          });
        that.setState({dataStock: temp});
      });
    }
  }

  getDate() {
    let date = new Date(new Date().toLocaleString("en-US", {timeZone: "America/Sao_Paulo"}));
    let day = dayOfWeek[date.getDay()];
    let month = date.toLocaleString('en-US', { month: 'long' });
    let hours = date.getHours();
    let minutes = date.getMinutes();
    let period = 'AM';

    if(Number(hours) < 10)
      hours = '0' + hours;
    if(Number(hours) > 12){
      period = 'PM';
      hours = Number(hours) - 12;
      if(hours < 10)
        hours = '0' + hours;
    }
    if(Number(minutes) < 10)
      minutes = '0' + minutes;

    return `${this.state.translations[day]}, ${this.state.translations[month]} ${date.getDate()} - <b>${hours}:${minutes} ${this.state.translations[period]} - Brasília</b>`;
  }

  render() {
    return (
      <section className="CoinQuoteComponent" id="CoinQuoteComponent">
        <div className="desktop">
          <div className="">

              {
              this.state.dataStock.map((item, index) => { return (
                <div key={index} className="itemQuote" style={{fontSize: "14px", marginRight: "10px"}}>
                  <div className="textQuote">
                    <img src={item.image} className="imgQuote" style={{width: "20px"}} alt={this.state.translations.flag_icon}/>
                    {item.label}<br/>
                    <b>{(Number(item.open).toFixed(2) + '').replace('.', ',')} {item.label} | {(Number(item.close).toFixed(2) + '').replace('.', ',')} BRL</b>
                  </div>
                </div>
              )})}
            <br/>

            <div style={{fontSize: "14px"}} dangerouslySetInnerHTML={{__html: this.getDate()}} />
          </div>
        </div>
        <div className="mobile">
          <p onClick={()=>{this.setState({dispQuotes: !this.state.dispQuotes})}}><b>{this.state.translations.top_quotes}</b></p>
          <div className="dispQuotesMobile" style={(this.state.dispQuotes?{height: "90px"}:{height: "1px"})}>
            <div style={{width: "630px"}}>
              {
                this.state.data.map((item, index) => { return (
                  <div key={index} className="itemQuote" style={{fontSize: "14px"}}>
                    <img src={item.image} className="imgQuote" alt={this.state.translations.flag_icon}/>
                    <div className="textQuote">
                      {item.coin}<br/>
                      <b>{item.value} {this.state.translations.brl}</b>
                    </div>
                  </div>
                )})
              }
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default CoinQuote;
